// @ts-ignore
export const loading = (state) => state.processes > 0;
